import { render, staticRenderFns } from "./afterSalesDetails.vue?vue&type=template&id=0ea5cd2e&scoped=true"
import script from "./afterSalesDetails.vue?vue&type=script&lang=js"
export * from "./afterSalesDetails.vue?vue&type=script&lang=js"
import style0 from "./afterSalesDetails.vue?vue&type=style&index=0&id=0ea5cd2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea5cd2e",
  null
  
)

export default component.exports